import { render, staticRenderFns } from "./tip-validate.vue?vue&type=template&id=68a3ec5e"
import script from "./tip-validate.vue?vue&type=script&lang=js"
export * from "./tip-validate.vue?vue&type=script&lang=js"
import style0 from "./tip-validate.vue?vue&type=style&index=0&id=68a3ec5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports